import {
  getExtendedErrorText,
  mainApi,
  queryFnNotifyWrapper,
} from 'modules/api';
import { getConnectedIotaProvider } from 'modules/auth';
import { authCacheTags } from 'modules/auth/authCacheTags';

interface ISwitchAccountParams {
  account: string;
}

export const { useSwitchAccountMutation } = mainApi.injectEndpoints({
  endpoints: build => ({
    switchAccount: build.mutation<void, ISwitchAccountParams>({
      queryFn: queryFnNotifyWrapper<ISwitchAccountParams, never, boolean>(
        // eslint-disable-next-line @typescript-eslint/require-await
        async ({ account: newAccount }) => {
          const provider = getConnectedIotaProvider();
          provider.updateWalletAccount(newAccount);

          return { data: true };
        },
        error => getExtendedErrorText(error, 'Failed to switch account'),
      ),
      invalidatesTags: [authCacheTags.account],
    }),
  }),
});
